/**
 * Encapsulates calls to module react-string-replace
 * This shouldn't be necessary bug a bug in the module prevents the correct work
 *  when replacing regexp matches.
 */

import reactStringReplace from 'react-string-replace';

export default function(subject, search, replaceCallback) {
    let result = [subject];

    _(subject.match(search)).each(match => {
        result = _(result)
            .map(string => {
                if (_.isString(string)) {
                    return reactStringReplace(string, match, replaceCallback);
                }
                return string;
            })
            .flatten()
            .value();
    });

    return result;
};
